module.exports = __webpack_public_path__ + "static/media/hospital.3365d295.png";